<div class="top-nav">
  <div class="logo-container">
    <img id="main-logo" src="assets/images/lenexa-logo.png" alt="Lenexa Logo">
  </div>

  <div class="header-menu">
    
    <div class="version-info" *ngIf="hasRoute('dashboard') || (hasRoute('help') && isUserLoggedIn())">
      Version: {{presentVersionBuild}}
    </div>

    <div class="nav-item modern-btn" *ngIf="orgImg && (hasRoute('dashboard') || (hasRoute('help') && isUserLoggedIn()))" (click)="navigateToOrganization()">
      <img class="nav-icon" [src]="orgImg" alt="Organizations">
      <span class="nav-text">Organizations</span>
    </div>

    <div class="nav-item modern-btn" *ngIf="userImg && (hasRoute('dashboard') || hasRoute('connector') || (hasRoute('help') && isUserLoggedIn()))" (click)="user_role()">
      <img class="nav-icon admin-icon" [src]="userImg" alt="Admin">
      <span class="nav-text">Admin</span>
    </div>

    <div class="nav-item modern-btn" *ngIf="hasRoute('connector') || (hasRoute('help') && isUserLoggedIn())" (click)="hasRoute('help') ? updateDashboard() : navigateTODashboard()">
      <img class="nav-icon" src="assets/images/hom-btn.png" alt="Dashboard">
      <span class="nav-text">Dashboard</span>
    </div>

    <div class="nav-item modern-btn" *ngIf="hasRoute('help') && !isUserLoggedIn()" (click)="navigateToLogin()">
      <span class="nav-text">Login</span>
    </div>

    <div class="nav-item modern-btn" *ngIf="hasRoute('admin')" (click)="navigateDashboard()">
      <img class="nav-icon" src="assets/images/dashboard-img.png" alt="Dashboard">
      <span class="nav-text">Dashboard</span>
    </div>

    <div class="nav-item modern-btn add-device-btn" *ngIf="hasRoute('dashboard')" (click)="onAddDevice()">
      <span class="nav-text">Add device</span>
    </div>

    <div class="nav-item modern-btn unpair-device-btn" *ngIf="hasRoute('dashboard')" (click)="onUnpairDevice()">
      <span class="nav-text">Unpair device</span>
    </div>

    <div class="nav-item modern-btn" *ngIf="isHelpAvailable()" (click)="fileOpen()">
      <img class="nav-icon" src="assets/images/help_button.svg" alt="Help">
      <span class="nav-text">Help</span>
    </div>

    <div class="nav-item modern-btn logout-btn" *ngIf="hasRoute('dashboard') || hasRoute('organization') || (hasRoute('help') && isUserLoggedIn())" (click)="navigateToConnection()">
      <img class="nav-icon" src="assets/images/logout.svg" alt="Logout">
      <span class="nav-text">Logout</span>
    </div>

  </div>
</div>